var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0739 6.11415L4.40452 0.444721L0.411725 4.43752L6.08115 10.1069L0.669426 15.5187L4.85235 19.7016L10.2641 14.2899L15.9681 19.9939L19.9609 16.0011L14.2569 10.2971L19.7016 4.85235L15.5187 0.669427L10.0739 6.11415Z","fill":"currentColor"}));
}

Close.defaultProps = {"aria-hidden":"true","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
